import React, { useCallback } from 'react';
import { Container, Card, CardBody, Button, Spinner } from 'reactstrap';

import { Link, useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import BuyersList from './components/buyers-list';
const Buyers = (props) => {
  const history = useHistory();
  const [buyers, , buyersLoading] = useGet(
    '/buyers?filter[include][0][relation]=district&filter[order]=createdAt DESC',
    true
  );

  const handleEditBuyer = useCallback(
    (obj) => {
      history.push(`/users/edit-buyer/${obj.id}`);
    },
    [history]
  );
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Buyers</h4>
          </div>
          <Card>
            <CardBody>
              {buyersLoading ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <BuyersList
                  buyers={buyers}
                  editBuyer={handleEditBuyer}
                ></BuyersList>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default Buyers;
